import { SupabaseClient } from "@supabase/auth-helpers-react";

export type UserState = {
    martianUser: MartianUser | undefined;
    custodialWalletAddress: string | undefined;
    loggedIn: boolean;
    loading: boolean;
    error: UserError;
};

// export type CustodialSettings = {
//     custodialWalletUsed: boolean;
//     custodialWalletAddress: string | undefined;
// }

export type MartianUser = {
    id: string;
    martianName: string;
    avatarUrl: string;
    hasSetup: boolean;
    hasCustodialWallet: boolean | undefined;
    walletAddress?: string | undefined;
    email?:string | undefined;
    firstName?: string | undefined;
    lastName?:string | undefined;
};

export enum UserError {
    NONE,
    LOADING_FAILED
}

export type FetchUserParams = {
    supabase: SupabaseClient<any, "public", any>;
    userId: string;
}

export type FetchUserCustodialDetailsParams = {
    supabase: SupabaseClient<any, "public", any>;
    userId: string;
}